/**
 *----------------------------------------------------------------------
 * Copyright (c) 2023 - 2024 SOMEI
 *
 * Handle exceptions
 *
 * -----
 * @summaryHandle exceptions
 * @author: wmegel
 * -----
 * Created Date: 08/02/2023 - 17:50:42
 * -----
 * Last Modified: 17/05/2024 - 08:28:7
 * Modified By: wmegel
 * -----
 *----------------------------------------------------------------------
*/

// @flow
import { get } from 'lodash';
import { put } from 'redux-saga/effects';
import { actionTypes as errorActionTypes } from '../modules/error';
import { destroySession } from '../modules/authentication';
import translate from '../services/Translation';

export default function* handleApiException (error: any) {
  switch (get(error, 'response.body.code') || error.code) {
      case 'ERR_TECH_NOT_AUTHORIZED':
      case 'ForbiddenException':
        return yield put({ type: errorActionTypes.ERROR_ACTION, error: translate('unauthorizedActionSession') });
      case 'UserNotFoundException':
      case 'NotAuthorizedException':
          return yield put({ type: errorActionTypes.ERROR_ACTION, error: translate('NotAuthorizedException') });
      case 'InvalidPasswordException':
          return yield put({ type: errorActionTypes.ERROR_ACTION, error: error.message});
      case 'UserSessionExpiredException':
          return yield destroySession();
    default:
      console.log(error);
    if(error.status === 400) return yield put({ type: errorActionTypes.ERROR_ACTION, error: translate('compaignUploadBadRequest') });
    if(error.status !== 200) return yield put({ type: errorActionTypes.ERROR_ACTION, error: translate('serverError') });

  }
};